module.exports = __webpack_public_path__ + "media/long-expected.b6c20827.ogg";